<template lang="html">
  <div>
    <b-modal ref="modal-aviso" centered hide-footer modal-class="modal-user-access-layout" @hide="$parent.openedModal = null;"title="Aviso de privacidad" >
      <div v-html="$root.extras.aviso">
      	
      </div>
      
    </b-modal>
  </div>
</template>

<script>
export default {
  data(){
    return{


    }
  },

  methods: {
   
  },

  watch: {
    '$parent.openedModal': function (val, oldVal) {
      if(val == 'aviso'){
        this.$refs['modal-aviso'].show();
      }
    }
  },

  mounted(){

  },
}
</script>
